import stores from '../store';

const memoized = {};

function getEmployee(employeeId) {
  if (
    typeof stores.employeeStore.employees === 'undefined' ||
    !stores.employeeStore.employees.length
  ) {
    return '_';
  }

  const filteredEmployees = stores.employeeStore.employees.filter((employee) => {
    return employee.id === employeeId;
  });

  if (!filteredEmployees.length) {
    return '_';
  }

  return filteredEmployees[0];
}

export default (employeeId) => {
  if (typeof memoized[employeeId] !== 'undefined') {
    return memoized[employeeId];
  }

  const employee = getEmployee(employeeId);

  if (employee !== '_') {
    memoized[employeeId] = employee;
  }

  return employee;
};



// WEBPACK FOOTER //
// ./src/utils/getEmployeeById.js